/**
 * Screen Wake Lock API Detector
 */

export interface WakeLockResult {
  supported: boolean;
}

export async function detectScreenWakeLock(): Promise<WakeLockResult> {
  try {
    const wakeLock = (navigator as Navigator & { wakeLock?: unknown }).wakeLock;
    return {
      supported: !!wakeLock,
    };
  } catch (error) {
    return {
      supported: false,
    };
  }
}
